import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-20 border-t border-[#1A1F2C]/10 bg-[#FDFBF7]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-10 grid gap-6 md:grid-cols-4 text-sm">
        <div>
          <div className="font-display text-xl text-[#1A1F2C]">LocaNest</div>
          <div className="text-[10px] uppercase tracking-[0.25em] text-[#5C6B7A] mt-1">Your verified rental partner</div>
          <p className="text-[#5C6B7A] mt-3 leading-relaxed">Verified rentals across India. Real photos. Direct listings. Deals completed on the platform stay protected.</p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.22em] text-[#5C6B7A] mb-2">Discover</div>
          <ul className="space-y-1.5">
            <li><Link to="/listings" className="hover:text-[#C85A32]">Listings</Link></li>
            <li><Link to="/vendors" className="hover:text-[#C85A32]">Top Vendors</Link></li>
            <li><Link to="/map" className="hover:text-[#C85A32]">Map view</Link></li>
            <li><Link to="/support" className="hover:text-[#C85A32]" data-testid="footer-support">Help &amp; Support</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.22em] text-[#5C6B7A] mb-2">Legal</div>
          <ul className="space-y-1.5">
            <li><Link to="/terms" className="hover:text-[#C85A32]" data-testid="footer-terms">Terms &amp; Conditions</Link></li>
            <li><Link to="/privacy" className="hover:text-[#C85A32]" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/refund-policy" className="hover:text-[#C85A32]" data-testid="footer-refund">Refund &amp; Cancellation</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.22em] text-[#5C6B7A] mb-2">Contact</div>
          <ul className="space-y-1.5 text-[#5C6B7A]">
            <li><a href="mailto:official@locanest.in" className="hover:text-[#C85A32]">official@locanest.in</a></li>
            <li>Payments powered by Cashfree</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#1A1F2C]/10 py-4 text-center text-xs text-[#5C6B7A]">
        © {new Date().getFullYear()} LocaNest · All rights reserved
      </div>
    </footer>
  );
}
